import { includes } from 'ramda';
import React from 'react';
import { toast } from 'react-toastify';

import BasicText from '@ui/atoms/BasicText';
import FlexColumn from '@ui/atoms/FlexColumn';

export const getServiceDisplayName = (serviceType: 'HRT_E' | 'HRT_T' | 'INJ' | string): string => {
	switch (serviceType) {
		case 'HRT_E':
		case 'GAHT_E':
			return 'Estrogen HRT';

		case 'HRT_T':
		case 'GAHT_T':
			return 'Testosterone HRT';

		case 'INJ': {
			return 'Injection Training';
		}

		case 'MHM':
		case 'MH_MEDICATION':
			return 'Medication Management';

		case 'MHT':
		case 'MH_THERAPY':
			return 'Talk Therapy';

		case 'VC':
		case 'PRIMARY_CARE':
			return 'Virtual Care';

		case 'TRANSFER':
			return 'Transfer';

		default: {
			return 'Clinician Appointment';
		}
	}
};

export const showAppointmentToast = (stateOfResidence = '') => {
	const relevantStates = ['IN', 'LA', 'SC', 'TN'];
	if (includes(stateOfResidence, relevantStates)) {
		toast.info(
			<FlexColumn>
				<BasicText color="white">If there are no appointments available</BasicText>
				<BasicText variant="fineprint" color="white">
					reach out in the Message Center
				</BasicText>
			</FlexColumn>
		);
	}
};
